import axios from './_nestAxios'

export const obtenerxIdAsEdicion = id => axios.get(`/proyectos/${id}`)

export const obtenerAsSelect = () => axios.get('/proyectos', { params: { tipoConsulta: 'select' } })

export const nuevo = data => axios.post('/proyectos', data)

export const actualizarxId = (id, data) => axios.put(`/proyectos/${id}`, data)

export const eliminarxId = id => axios.delete(`/proyectos/${id}`)
